<script setup lang="ts">
export interface EventStatsProps {
  /**
   * Event data.
  */
  event?: IModelEvent | null;
  /**
   * Data with match score stats.
  */
  scoreStats?: IEventScoreStats | null;
  /**
   * Data with match overview stats.
  */
  gameStats?: IEventGameStats | null;
}
const props = defineProps<EventStatsProps>();
</script>

<template>
  <template v-if="props.event?.geniusId">
    <EventStatsGenius :id="props.event.geniusId" />
  </template>
  <template v-else-if="props.scoreStats || props.gameStats">
    <div class="max-lg:max-h-[49vh]">
      <div v-if="props.scoreStats">
        <EventStatsScoreboard
          :team1-name="props.event?.team1Name"
          :team2-name="props.event?.team2Name"
          :team1-logo-url="props.event?.team1LogoUrl"
          :team2-logo-url="props.event?.team2LogoUrl"
          :team1-color="props.event?.team1Color"
          :team2-color="props.event?.team2Color"
          :team1-score="props.scoreStats?.team_home.total || props.gameStats?.team_home.total"
          :team2-score="props.scoreStats?.team_away.total || props.gameStats?.team_away.total"
        />
        <div role="separator" class="hr" style="background: var(--base-background-color)" />
        <EventStatsTableScore
          :team1-logo-url="props.event?.team1LogoUrl"
          :team2-logo-url="props.event?.team2LogoUrl"
          :team1-color="props.event?.team1Color"
          :team2-color="props.event?.team2Color"
          :stats-data="props.scoreStats"
        />
      </div>

      <div v-if="props.gameStats">
        <div role="separator" class="hr" style="background: var(--base-background-color)" />
        <EventStatsTableGame
          :team1-name="props.event?.team1Name"
          :team2-name="props.event?.team2Name"
          :team1-logo-url="props.event?.team1LogoUrl"
          :team2-logo-url="props.event?.team2LogoUrl"
          :team1-color="props.event?.team1Color"
          :team2-color="props.event?.team2Color"
          :stats-data="props.gameStats"
        />
      </div>
    </div>
  </template>
</template>
